import { useState, useEffect, useRef } from "react";

import Modal from "react-bootstrap/Modal";

import { api, cleanAIAnswer, parseArray, robustJsonParse, speakGerman } from "../pureFunctions";
import { Button, Form, Col, Alert, Row, Spinner, Table, ButtonGroup } from "react-bootstrap";
import { header } from "../globalVariables";

import aiIcon from "../img/ki.png";
import editIcon from "../img/edit.png";

import { milieuForm, milieuOutputConfig, milieuPrompt, milieuTexte } from "./MilieuData";
import TextMitZeilennummern from "../Zeilennummern";
import NummerierteSaetze from "../NummerierteSaetze";
import { formatText } from "../formatFunctions";
import { useContextMenu, ContextMenu, getItemsForContext } from "../Utils/ContextMenu";
import MyProgressBar from "../Tools/MyProgressBar";
import { SpinnerGroup } from "../Utils/SpinnerGroup";
import { debouncedSaveEstateData, saveEstateData } from "../networkFunctions";
import LoadingAnimation from "../LoadingAnimation";
import Gallery from "../DropBoxGallery";
import GalleryParent from "../DropBoxGalleryParent";
import { useConfig } from "../ConfigContext";

export default function AIExpoImages({
   dbxData,
   estateId,
   imageResult,
   setImageResult,
   aiLoading,
   setAiLoading,
   user,
}) {
   const config = useConfig();
   const [currentTab, setCurrentTab] = useState("dataCheck");
   const [openGallery, setOpenGallery] = useState(false);
   const [selectedImages, setSelectedImages] = useState({});

   async function analyzeImages(images) {
      console.log(images);
      setAiLoading((prev) => ({ ...prev, images: "loading" }));

      const imageResp = await api.post("/api/ai_img_analyse", { paths: Object.keys(images) }, header).then((data) => {
         console.log(data);
         return robustJsonParse(data?.data?.resp);
      });
      const parsedImageData = imageResp.map((item) => {
         const imgData = Object.values(images).find((imgItem) =>
            imgItem.path.toLowerCase().includes(item.datei.toLowerCase()),
         );
         return { ...item, imgData };
      });
      console.log(parsedImageData);

      saveEstateData({ aiImages: parsedImageData }, estateId);
      setImageResult(parsedImageData);
      setAiLoading((prev) => ({ ...prev, images: false }));
   }

   return (
      <>
         <div>
            <Button
               onClick={() => {
                  setOpenGallery(true);
               }}
            >
               Bilder auswählen
            </Button>
            {Object.values(selectedImages).length > 0 && (
               <>
                  <div
                     className="my-1"
                     style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                        gap: 6,
                     }}
                  >
                     {Object.values(selectedImages).map((imgItem) => (
                        <div key={imgItem.id} className="text-center">
                           <img
                              src={imgItem?.thumbnail || "placeholder.png"}
                              alt={imgItem?.name}
                              loading="lazy"
                              style={{
                                 width: "100%",
                                 aspectRatio: "3 / 2",
                                 objectFit: "cover",
                                 borderRadius: 10,
                              }}
                           />
                           <div>{imgItem?.name}</div>
                        </div>
                     ))}
                  </div>

                  <div>
                     <Button
                        onClick={() => {
                           console.log(selectedImages);

                           analyzeImages(selectedImages);
                        }}
                     >
                        Bilder analysieren
                     </Button>
                  </div>
               </>
            )}

            {/*  {imageResult && (
                        <div style={{ whiteSpace: "pre-wrap", fontFamily: "monospace" }}>
                           {JSON.stringify(imageResult, null, 2)}
                        </div>
                     )} */}
            {imageResult && (
               <div style={{ whiteSpace: "pre-wrap", fontFamily: "monospace" }}>
                  {imageResult?.map((item) => {
                     return (
                        <div style={{ padding: 10, margin: 10, border: "solid 1px #ddd" }}>
                           <h5>{item.datei}</h5>
                           {item.imgData && (
                              <img
                                 src={item.imgData?.thumbnail || "placeholder.png"}
                                 alt={item.imgData?.name}
                                 loading="lazy"
                                 style={{ width: "200px", borderRadius: 4 }}
                              />
                           )}
                           <p>
                              <strong>Raumtyp</strong>
                              <br />
                              {item.raumtyp}
                           </p>
                           <p>
                              <strong>Ausstattung</strong>
                              <br />
                              {item.ausstattung}
                           </p>

                           <p>
                              <strong>Zustand</strong>
                              <br />
                              {item.zustand}
                           </p>
                           <p>
                              <strong>Licht & Atmosphäre</strong>
                              <br />
                              {item.lichtUndAtmosphaere}
                           </p>
                           <p>
                              <strong>Highlights</strong>
                              <br />
                              {item.highlights}
                           </p>
                           <p>
                              <strong>unsicher</strong>
                              <br />
                              {item.unsicher}
                           </p>
                        </div>
                     );
                  })}
               </div>
            )}

            {/* "bild": 1,
    "datei": "og.jpg",
    "raumtyp": "Grundriss (möbliert dargestellt, 3D-Visualisierung von oben) einer Wohnung im Obergeschoss",
    "ausstattung": "Erkennbare Räume laut Beschriftung bzw. Darstellung: Flur als zentrale Verteilerfläche; Küche mit Esstisch und vier Stühlen; ein Bad mit Badewanne (Beschriftung nur teilweise lesbar, vermutlich 'Tages-/Bad'); Wohnzimmer mit Sofa, Couchtisch, Sessel und Arbeitsplatz/Schreibtisch im Bereich des Wohnzimmers; Balkon mit zwei Stühlen und Tisch, angrenzend an das Wohnzimmer; ein Schlafzimmer mit Doppelbett und Kleiderbereich; ein zweites kleineres Zimmer mit Einzelbett und Schreibtisch (Kinder-/Gästezimmer oder Arbeitszimmer); ein schmaler Raum oben, beschriftet vermutlich als 'Abstellraum'. Im Schlafzimmer und im Bad sind Zimmerpflanzen dargestellt.",
    "zustand": "Nicht beurteilbar, da es sich um eine gerenderte Grundrissdarstellung mit virtueller Möblierung handelt. Keine Aussagen zu Bodenbelägen, Wandzustand oder Sanierungsstand möglich.",
    "lichtUndAtmosphaere": "Neutrale, helle Darstellung auf weißem Hintergrund. Die Fensterbereiche sind als Öffnungen in den Außenwänden angedeutet (u. a. an Küche, Schlafzimmern, Wohnzimmer). Die Möblierung vermittelt eine wohnliche Aufteilung, ist aber nur Visualisierung.",
    "highlights": "Klare Raumaufteilung mit zentralem Flur; Balkon am Wohnzimmer; separate Küche mit Essplatz; zwei Schlafräume plus separater Abstellraum; Badewanne im Bad.",
    "unsicher": "Keine Maßstabsangabe und keine Flächenangaben erkennbar, daher sind Raumgrößen und Gesamtwohnfläche nicht bestimmbar. Die Beschriftungen sind teils schlecht lesbar (z. B. Bad, Abstellraum, Zimmerbezeichnungen). Unklar ist, ob die dargestellte Möblierung dem realen Bestand entspricht. Ob es sich um das Obergeschoss handelt, ist nur aus dem Dateinamen 'og' abgeleitet. Himmelsrichtung, Deckenhöhen, Heizungsart und Ausstattung der Sanitärräume (z. B. Dusche, WC-Position) sind nicht klar erkennbar.",
    "eignungAlsTitelbild": "Gering. Der Grundriss eignet sich gut als Planbeilage im Exposé, aber nicht als Titelbild, da er keinen visuellen Eindruck von der Immobilie selbst vermittelt." */}
            {openGallery && (
               <GalleryParent
                  folderName={dbxData.name}
                  setOpenMedia={setOpenGallery}
                  allowRename={false}
                  setSelectedImages={setSelectedImages}
                  selectedImages={selectedImages}
               />
            )}
         </div>
      </>
   );
}
